module.exports = __webpack_public_path__ + "media/icons/send-circle-35e84177.svg";